import type {
  InvestmentReplayContributionInterval,
  InvestmentReplayMode,
  InvestmentReplayRun,
  InvestmentReplayRunDetail,
} from "@/types/api";
import { request } from "./transport";

export interface InvestmentReplayInput {
  readonly mode: InvestmentReplayMode;
  readonly tickers: readonly string[];
  readonly invested_at: string;
  readonly through: string;
  readonly amount: number;
  readonly contribution_interval: InvestmentReplayContributionInterval;
  readonly client_token?: string;
}

export type InvestmentReplayResponse =
  | { readonly status: "loading" }
  | {
      readonly status: "ready";
      readonly investment_replay_run: InvestmentReplayRunDetail;
    };

export const investmentReplays = {
  listInvestmentReplays: () =>
    request<{
      readonly investment_replay_runs: readonly InvestmentReplayRun[];
    }>("/investment_replays"),
  createInvestmentReplay: (input: InvestmentReplayInput) =>
    request<InvestmentReplayResponse>("/investment_replays", {
      body: JSON.stringify({ investment_replay: input }),
      method: "POST",
    }),
  getInvestmentReplay: (id: number) =>
    request<{ readonly investment_replay_run: InvestmentReplayRunDetail }>(
      `/investment_replays/${id}`,
    ),
  reorderInvestmentReplays: (runIds: readonly number[]) =>
    request<{
      readonly investment_replay_runs: readonly InvestmentReplayRun[];
    }>("/investment_replays/reorder", {
      body: JSON.stringify({ investment_replay_run_ids: runIds }),
      method: "PATCH",
    }),
  deleteInvestmentReplay: (id: number) =>
    request<{ readonly ok: true }>(`/investment_replays/${id}`, {
      method: "DELETE",
    }),
};
